import { Component, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoginService } from './services/login.service';

@Component({
  selector: 'ngx-app',
  template: `<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
            <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  loading: boolean;
  constructor(private router: Router, private loginService: LoginService
  ) {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit() {
  }

}
